import React, { useState, useEffect, useRef } from "react";
import "./game.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { database } from "../../database/firebase";
import { getFirestore, increment, serverTimestamp, doc, getDoc, updateDoc, addDoc, setDoc, collection, query, orderBy, where, getDocs, onSnapshot, listCollections, Timestamp } from "firebase/firestore";
import Modal from "react-modal";
import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback


function Game({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, SetriddlerusLogo] = useState("/img/logo.png");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
  //const themeData1 = JSON.parse(sessionStorage.getItem('themeData'));
  const [initialFund, setinitialfundData] = useState(null);
  const [balance, setbalancefundData] = useState(null);
  const [textcolor, Setcolorcode] = useState(null);
  const [stocks, setStocks] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionSet, setQuestionSet] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answer, setAnswer] = useState(0); // default slider value
  const [CurrentCompany, setCurrentCompany] = useState(0); // default slider value
  const [loading, setLoading] = useState(true); // loading state
  const [QuestionsReady, setQuestionsReady] = useState(false); // loading state
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
  const disclaimerAcceptedRef = useRef(false);
  const pendingValidationRef = useRef(null);
  const pendingRedirectRef = useRef(null);
  const ratingLabels = ["Very Poor", "Poor", "Neutral", "Good", "Excellent"];

  const showValidationAlert = (options) => {
    if (!disclaimerAcceptedRef.current) {
      pendingValidationRef.current = options;
      return;
    }
    Swal.fire(options);
  };

  const handleSuccess = (msg) => {
    showValidationAlert({
      title: 'Success!',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };
  function htmlspecialchars_decode(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }
  const shuffleArray = (array) => {
    return array
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
  };

  useEffect(() => {
    updateHeader({
      backButtonRedirect: "/intro"
    });

    const fetchData = async () => {
      const storedSession = sessionStorage.getItem("userData");

      const storedTheme = sessionStorage.getItem("themeData");

      if (storedSession && storedTheme) {
        const parsedUser = JSON.parse(storedSession);
        const parsedTheme = JSON.parse(storedTheme);
        console.log(parsedTheme);
        setUserData(parsedUser);
        setThemeData(parsedTheme);
        Setcolorcode(parsedTheme.landing_page_title_color);

      } else {
        navigate("/login"); // Redirect if session data is missing
      }
    };

    fetchData();

    Swal.fire({
      title: 'Disclaimer',
      html: '<p>Virtual Market Challenge is an educational and entertainment-based simulation for users aged 18 years and above. It does not involve real money, actual stocks, securities, investments, deposits, withdrawals, or financial returns. All currency and assets shown are virtual.</p><p>Apple Inc. is not a sponsor of, affiliated with, or involved in this  Virtual Market Challenge in any manner.</p>',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
      heightAuto: false,
      scrollbarPadding: false,
      customClass: {
        popup: 'custom-success-popup'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        disclaimerAcceptedRef.current = true;
        setDisclaimerAccepted(true);
        if (pendingValidationRef.current) {
          Swal.fire(pendingValidationRef.current);
          pendingValidationRef.current = null;
        }
        if (pendingRedirectRef.current) {
          pendingRedirectRef.current();
          pendingRedirectRef.current = null;
        }
      }
    });

  }, [database, navigate]);


  function loadCompanies(sessionId, themename) {
    if (!sessionId) {
      console.warn("Session ID is missing. Cannot fetch news.");
      return;
    }

    const companiesRef = collection(database, "companies"); // Reference to "news" collection
    const q = query(
      companiesRef,
      where("sessionId", "==", sessionId),
      where("themename", "==", themename)
    ); // Filter by sessionId

    getDocs(q)
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          const companiesData = querySnapshot.docs.map((doc) => ({
            id: doc.id, // Document ID
            compId: doc.id,
            ...doc.data(), // Document fields
          }));
          console.log("Fetched companies Data:", companiesData);
          setStocks(companiesData);
        } else {
          console.warn("No companies documents found for sessionId:", sessionId);
          setStocks([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching news:", error);
      });
  }


  const loadQuestions = async (sessionId, userId, themename) => {
    if (!sessionId || !themename || !userId)
      return console.warn("Session ID, User ID, or Theme missing");

    setLoading(true);
    const questionSetRef = collection(database, "questionSet");

    try {
      // 🔍 Check if questionSet exists for sessionId + userId + themename
      const q = query(
        questionSetRef,
        where("sessionId", "==", sessionId),
        where("userId", "==", userId),
        where("themename", "==", themename)
      );

      const querySnapshot = await getDocs(q);
      let questionsData = [];
      let currentIdx = 0;

      if (!querySnapshot.empty) {
        // ✅ Existing questionSet found
        const docSnap = querySnapshot.docs[0];
        const data = docSnap.data();

        questionsData = data.questions || [];
        currentIdx = data.currentIndex || 0;

        console.log("Loaded existing questionSet from Firestore:", data);

        // 🚪 Check if quiz already completed
        if (currentIdx >= questionsData.length && questionsData.length > 0) {
          console.log("✅ User already completed this quiz.");
          handleSuccess("Already answered all the questions");
          setQuestionsReady(false);

          const goToUserpage = () => {
            setTimeout(() => {
              window.location.href = "/userpage";
            }, 1000);
          };
          if (!disclaimerAcceptedRef.current) {
            pendingRedirectRef.current = goToUserpage;
          } else {
            goToUserpage();
          }
          return;
        }

        // ✅ Set states immediately
        setQuestions(questionsData);
        setQuestionSet(questionsData);
        setCurrentIndex(currentIdx);
        setQuestionsReady(true);
      } else {
        // 🔍 No existing questionSet — fetch questions from "questions" collection
        const questionsRef = collection(database, "questions");
        const q2 = query(
          questionsRef,
          where("sessionId", "==", sessionId),
          where("themename", "==", themename)
        );

        const questionsSnapshot = await getDocs(q2);

        if (!questionsSnapshot.empty) {
          const questionsData = questionsSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          // const shuffled = shuffleArray(questionsData);
          const shuffled = questionsData;

          // ✅ Update UI immediately (before saving to Firestore)
          setQuestions(shuffled);
          setQuestionSet(shuffled);
          setCurrentIndex(0);
          setQuestionsReady(true);

          // Then save to Firestore asynchronously
          await setDoc(doc(questionSetRef), {
            questions: shuffled,
            currentIndex: 0,
            sessionId,
            themename,
            userId,
            createdAt: new Date().toISOString(),
          });

          console.log("Created new questionSet in Firestore for user:", userId);
        } else {
          // ⚠️ No questions found for this theme/session
          console.warn("No questions found for this session/theme");
          setQuestions([]);
          setQuestionSet([]);
          setQuestionsReady(false);

          showValidationAlert(
            "No questions are available for this theme yet. Please wait for the admin to add questions."
          );
          return;
        }
      }
    } catch (error) {
      console.error("Error loading questionSet:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleSliderChange = async (e, companyName) => {
    const value = Number(e.target.value);
    setAnswer(value);

    setCurrentCompany(companyName);
  };

  const handleNext = async () => {
    // Check if user changed the slider value
    // if (answer === 0) {
    //   Swal.fire("Please move the slider to select your answer before continuing.");
    //   return;
    // }

    if (currentIndex < questionSet.length - 1) {
      const newIndex = currentIndex + 1;

      try {
        // Update currentIndex in Firestore for matching sessionId + themename
        const questionSetRef = collection(database, "questionSet");
        const q = query(
          questionSetRef,
          where("sessionId", "==", userData.sessionId),
          where("userId", "==", userData.userId),
          where("themename", "==", themeData.themeName)
        );

        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const docRef = querySnapshot.docs[0].ref; // first matching doc
          await setDoc(
            docRef,
            { currentIndex: newIndex },
            { merge: true }
          );
          console.log("✅ Updated currentIndex in Firestore:", newIndex);

          // Wait for price update before showing next question
          await updateCurrentPrice();
          console.log("✅ Price updated");

          // Now show next question
          setCurrentIndex(newIndex);
          setAnswer(0); // reset slider for next question
        } else {
          console.warn("⚠️ No matching questionSet found for update.");
        }
      } catch (error) {
        console.error("❌ Error updating currentIndex:", error);
      }
    } else {
      console.log("🎯 End of questions — show submit or navigate next");
    }
  };

  const updateCurrentPrice = async () => {
    try {
      // Query companies collection
      const companiesRef = collection(database, "companies");
      const q = query(
        companiesRef,
        where("companyname", "==", CurrentCompany),
        where("sessionId", "==", userData.sessionId),
        where("themename", "==", themeData.themeName)
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docRef = querySnapshot.docs[0].ref; // reference to update the document
        const docData = querySnapshot.docs[0].data();
        const currentPrice = docData.currentprice;
        // alert(answer);
        // alert(CurrentCompany);

        let impact = 10;
        let impactType = answer <= 1 ? "Positive" : "Negative";

        // Use your existing helper function
        const updatedPrice = calculateStockPrice(currentPrice, impact, impactType);

        // ✅ Update Firestore with the new price
        await updateDoc(docRef, { currentprice: updatedPrice });

        loadCompanies(userData.sessionId, themeData.themeName);

        console.log(
          `✅ Updated ${CurrentCompany} | Old: ${currentPrice}, New: ${updatedPrice}`
        );
      } else {
        console.warn("⚠️ No matching company found for:", CurrentCompany);
      }
    } catch (error) {
      console.error("❌ Error fetching/updating company data:", error);
    }
  };


  const handleSubmit = async () => {
    // Check if user changed the slider value
    // if (answer === 0) {
    //   alert("Please move the slider to select your answer before continuing.");
    //   return;
    // }

    const newIndex = currentIndex + 1;

    try {
      // Update currentIndex in Firestore for matching sessionId + themename
      const questionSetRef = collection(database, "questionSet");
      const q = query(
        questionSetRef,
        where("sessionId", "==", userData.sessionId),
        where("userId", "==", userData.userId),

        where("themename", "==", themeData.themeName)
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docRef = querySnapshot.docs[0].ref; // first matching doc
        await setDoc(
          docRef,
          { currentIndex: newIndex },
          { merge: true }
        );
        console.log("✅ Updated currentIndex in Firestore:", newIndex);

        // Wait for price update before showing next question
        await updateCurrentPrice();
        console.log("✅ Price updated");

        // Now show next question
        setCurrentIndex(newIndex);
        setAnswer(0); // reset slider for next question
        navigate("/userpage"); // Redirect if session data is missing
        console.log("Submitting all answers...");
      } else {
        console.warn("⚠️ No matching questionSet found for update.");
      }
    } catch (error) {
      console.error("❌ Error updating currentIndex:", error);
    }

  };

  function calculateStockPrice(price, percentage, type) {
    console.log(price, percentage, type);
    if (type === "Positive") {
      return price * (1 + (percentage / 100)); // Increase stock price
    } else {
      let newPrice = price * (1 - (percentage / 100)); // Decrease stock price
      return newPrice < 0 ? 0 : newPrice; // Ensure price doesn't go below 0
    }
  }

  useEffect(() => {
    if (!themeData || !userData) return;

    const gameRef = doc(database, `sessions/${userData.sessionId}/themes/${themeData.themeName}`);

    const unsubscribe = onSnapshot(gameRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const gameData = docSnapshot.data();
        console.log("userData", userData);
        console.log("Game Data:", gameData);
        loadCompanies(userData.sessionId, themeData.themeName);
        loadQuestions(userData.sessionId, userData.userId, themeData.themeName);

      } else {
        console.warn("Game session document does not exist.");
      }
    });

    return () => unsubscribe();
  }, [database, themeData, userData]); // ✅ Removed unnecessary dependencies

  useEffect(() => {
    if (themeData != null) {
      const body = document.body;

      if (body.classList.contains('common-bg')) {
        // Check if it's a mobile device (or you can define your own breakpoint)
        if (window.innerWidth <= 768) {
          // Apply mobile background
          console.log(themeData.background_mob);
          body.style.backgroundImage = `url(${themeData.background_mob})`;
        } else {
          // Apply desktop background
          console.log(themeData.background_desk);
          body.style.backgroundImage = `url(${themeData.background_desk})`;
        }
      }

      SetriddlerusLogo(themeData.logo);
    }
  }, [themeData]);

  return (
    <>
      <div className="game-livestock-main-container" style={{ textAlign: "center" }}>
        <div className="livestock" style={{ opacity: "0.5","paddingLeft": "0px", "paddingRight": "0px", borderRadius: "8px",  width:"100%",boxShadow: "2px 2px 8px rgba(0,0,0,0.1)" }}>
          <h2 style={{ color: textcolor }}>Live Stock Prices</h2>
          <div className="livestock-child"
            style={{
        
              backgroundColor: "rgba(0, 0, 0, 0.7)", // Wrapped in quotes
              border: "1px solid white",
              borderRadius: "10px",
              width:"100%"
            }}
          >

            <table style={{ borderCollapse: "collapse", borderSpacing: 0 }}>
              <thead>
                <tr>
                  <th>Company Name</th>
                  {/* <th>Stock Price</th>
                  <th>Quantity</th> */}
                  <th>Stock Current Price</th>
                  <th>Status</th>
                  <th>Profit/Loss</th>
                </tr>
              </thead>
              <tbody>
                {stocks.map((stock) => {
                  const profitLoss = stock.currentprice - stock.stockprice;
                  console.log(stock.currentprice,"-------",stock.stockprice);

                  const isProfit = profitLoss > 0;
                  console.log("isProfit-------",isProfit);
                  return (
                    <React.Fragment key={stock.id}>
                      <tr
                        style={{
                          cursor: "pointer",
                          backgroundColor: "transparent", // 🔹 highlight expanded row
                          transition: "background-color 0.3s ease",
                        }}
                      >
                        <td className="tooltip">
                          <div className="company-name">
                            {stock.companyname}

                          </div>
                        </td>
                        {/* <td>{stock.stockprice}</td>
                        <td>{stock.currentQut}</td> */}
                        <td>{stock.currentprice.toFixed(2)}</td>
                        <td style={{ color: isProfit ? "green" : "red" }}>
                                {isProfit ? "▲" : "▼"}
                              </td>
                              <td style={{ color: isProfit ? "green" : "red" }}>
                                {profitLoss.toFixed(2)}
                              </td>
                      </tr>


                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="game-main-container" style={{ textAlign: "center" }}>
        <div className="game-main-container1" style={{ textAlign: "center" }}>
          <img src={riddlerusLogo} className="game-logo" />
        </div>
        <div className="gametitle">
          <h3 style={{ color: textcolor }}>
            Your wellbeing drives the market — invest in yourself, and see how the world of wellness reacts
          </h3>
        </div>
        <div className="text-main-container" style={{ marginTop: "20px", color: textcolor }}>
          {loading || !questionSet || questionSet.length === 0 ? (
            <p>Loading questions...</p> // show only while fetching
          ) : (questionSet.length > 0 && QuestionsReady) ? (
            <>

              <h3 style={{ color: textcolor }}>
                {htmlspecialchars_decode(questionSet[currentIndex].question)}
              </h3>
              <div style={{ textAlign: "center", width: "100%", marginTop: "20px" }}>
                <input
                  type="range"
                  min="0"
                  max="4"
                  value={answer}
                  onChange={(e) =>
                    handleSliderChange(e, questionSet[currentIndex].companyname)
                  }
                  className="custom-slider"
                  style={{
                    width: "80%",
                    background: `linear-gradient(
                        to right,
                        #4caf50 0%,
                        #4caf50 ${(answer / 4) * 100}%,
                        #fff ${(answer / 4) * 100}%,
                        #fff 100%
                      )`,
                  }}
                />

                {/* Labels below slider */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "90%",
                    margin: "5px auto 0",
                    fontSize: "14px",
                    color: "#555",
                    fontWeight: "500",
                  }}
                >
                  {ratingLabels.map((label, index) => (
                    <span
                      key={index}
                      style={{
                        color: answer === index ? "#4caf50" : "#ccc",
                        fontWeight: answer === index ? "600" : "400",
                        transition: "color 0.3s ease",
                      }}
                    >
                      {label}
                    </span>
                  ))}
                </div>

                {/* Display selected rating text */}
                {/* <p style={{ marginTop: "20px", color: textcolor }}>
                    Your rating: <strong>{ratingLabels[answer]}</strong>
                  </p> */}
              </div>
              {currentIndex < questionSet.length - 1 ? (
                <button className="nextbtn" onClick={handleNext} style={{ marginTop: "30px" }}>
                  <img src="/img/next-button.png" className="begin-play-img" />
                </button>
              ) : (
                <button className="nextbtn" onClick={handleSubmit} style={{ marginTop: "20px" }}>
                  <img src="/img/begin-play.png" className="begin-play-img" />
                </button>
              )}
            </>
          ) : (
            <p style={{ color: "red", marginTop: "20px" }}>
              No questions available. Please add questions from admin.
            </p>
          )}
        </div>
        {/* <div style={{ textAlign: "center" }}>
          <Link to="/userpage">
            <img src="/img/next-button.png" className="begin-play-img" />
          </Link>
        </div> */}
      </div>

    </>

  );
}
export default Game;